import React, { Component } from "react";
import { withTranslation } from "react-i18next";

import { Button, Card, CardBody, Col, Container, label, Row } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

class viewExternalUnit extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    //meta title
    document.title = "Manage organization";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem={this.props.t("Manage Organization")} />

            <Card>
              <CardBody>
                <div>
                  <h4 className="text-black fw-bold mb-5">
                  Edit Factory(External Unit)
                  </h4>
                </div>
                <form>
                  <div className="mb-3 row">
                    <label
                      htmlFor="factoryID"
                      className="col-md-2 col-form-label"
                    >
                      <h5 className="text-secondary fw-bold">
                        Factory(Unit) ID
                      </h5>
                    </label>
                    <div className="col-md-10">
                      <input
                        className="form-control fs-5 text-uppercase"
                        disabled
                        type="text"
                        name="factoryID"
                        placeholder="xxx0125fgtr"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label
                      htmlFor="factoryName"
                      className="col-md-2 col-form-label"
                    >
                      <h5 className="text-secondary fw-bold">
                        {this.props.t("Factory(Unit) Name")}
                      </h5>
                    </label>
                    <div className="col-md-10">
                      <input
                        className="form-control fs-5 text-uppercase"
                        disabled
                        type="text"
                        name="factoryName"
                        placeholder="xxx0125fgtr"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label
                      htmlFor="factoryType"
                      className="col-md-2 col-form-label"
                    >
                      <h5 className="text-secondary fw-bold">
                        {this.props.t("Factory(Unit) Type")}
                      </h5>
                    </label>
                    <div className="col-md-10">
                      <select
                        className="form-control fs-5"
                        name="factoryType"
                        disabled
                      >
                        <option value="" disabled>
                          select
                        </option>
                        <option value="Gujarat">Internal</option>
                        <option value="Maharashtra">External</option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label
                      htmlFor="partycode"
                      className="col-md-2 col-form-label"
                    >
                      <h5 className="text-secondary fw-bold">{this.props.t('Party Code')}</h5>
                    </label>
                    <div className="col-md-10">
                      <input
                        className="form-control fs-5 text-uppercase"
                        type="text"
                        name="partycode"
                        placeholder="xxx0125fgtr"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label
                      htmlFor="partyname"
                      className="col-md-2 col-form-label"
                    >
                      <h5 className="text-secondary fw-bold">{this.props.t('Party Name')}</h5>
                    </label>
                    <div className="col-md-10">
                      <input
                        className="form-control fs-5"
                        disabled
                        type="text"
                        name="partyname"
                        placeholder="XYZ Diamond"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label htmlFor="gst" className="col-md-2 col-form-label">
                      <h5 className="text-secondary fw-bold">{this.props.t("GST No.")}</h5>
                    </label>
                    <div className="col-md-10">
                      <input
                        className="form-control fs-5"
                        disabled
                        type="text"
                        name="gst"
                        placeholder="04AABCU9603R1ZV"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label htmlFor="pan" className="col-md-2 col-form-label">
                      <h5 className="text-secondary fw-bold">{this.props.t("Pan No.")}</h5>
                    </label>
                    <div className="col-md-10">
                      <input
                        className="form-control fs-5 text-uppercase"
                        disabled
                        type="text"
                        name="pan"
                        placeholder="AAECC6548C"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label htmlFor="cinNo" className="col-md-2 col-form-label">
                      <h5 className="text-secondary fw-bold">{this.props.t("CIN / LLP IN")}</h5>
                    </label>
                    <div className="col-md-10">
                      <input
                        className="form-control fs-5"
                        disabled
                        type="text"
                        name="cinNo"
                        placeholder="L01631KA2010PTC096843"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label htmlFor="tds" className="col-md-2 col-form-label">
                      <h5 className="text-secondary fw-bold">{this.props.t("TDS Rate")}</h5>
                    </label>
                    <div className="col-md-10">
                      <input
                        className="form-control fs-5"
                        disabled
                        type="text"
                        name="tds"
                        placeholder="01%"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label
                      htmlFor="address1"
                      className="col-md-2 col-form-label"
                    >
                      <h5 className="text-secondary fw-bold">Address line 1</h5>
                    </label>
                    <div className="col-md-10">
                      <input
                        className="form-control fs-5"
                        disabled
                        type="text"
                        name="address1"
                        placeholder="1901 Thornridge Cir. Shiloh, Hawaii 81063"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label
                      htmlFor="address2"
                      className="col-md-2 col-form-label"
                    >
                      <h5 className="text-secondary fw-bold">Address line 2</h5>
                    </label>
                    <div className="col-md-10">
                      <input
                        className="form-control fs-5"
                        disabled
                        type="text"
                        name="address2"
                        placeholder="1901 Thornridge Cir. Shiloh, Hawaii 81063"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label htmlFor="city" className="col-md-2 col-form-label">
                      <h5 className="text-secondary fw-bold">{this.props.t('City')}</h5>
                    </label>
                    <div className="col-md-10">
                      <input
                        className="form-control fs-5"
                        disabled
                        type="text"
                        name="city"
                        placeholder="City"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label htmlFor="state" className="col-md-2 col-form-label">
                      <h5 className="text-secondary fw-bold">State</h5>
                    </label>
                    <div className="col-md-10">
                      <select
                        className="form-control fs-5"
                        name="state"
                        disabled
                      >
                        <option value="" disabled>select</option>
                        <option value="Gujarat">Gujarat</option>
                        <option value="Maharashtra">Maharashtra</option>
                        <option value="Tamil Nadu">Tamil Nadu</option>
                        <option value="Uttar Pradesh">Uttar Pradesh</option>
                        <option value="West Bengal">West Bengal</option>
                        <option value="Karnataka">Karnataka</option>
                        <option value="Rajasthan">Rajasthan</option>
                        <option value="Andhra Pradesh">Andhra Pradesh</option>
                        <option value="Madhya Pradesh">Madhya Pradesh</option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label htmlFor="zip" className="col-md-2 col-form-label">
                      <h5 className="text-secondary fw-bold">{this.props.t("Zip Code")}</h5>
                    </label>
                    <div className="col-md-10">
                      <input
                        className="form-control fs-5"
                        disabled
                        type="text"
                        name="zip"
                        placeholder="Zip code"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <div className="col-md-6 col-12">
                      <div className="row">
                        <div className="col-md-4">
                          <label htmlFor="hpht" className="col-form-label">
                            <h5 className="text-secondary fw-bold">
                              {this.props.t("CVD Rate")}
                            </h5>
                          </label>
                        </div>
                        <div className="col-md-8">
                          <input
                            className="form-control fs-5"
                            disabled
                            type="text"
                            name="hpht"
                            placeholder="Different Rate"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <div className="row">
                        <div className="col-md-4 text-start text-lg-center">
                          <label htmlFor="lpht" className="col-form-label">
                            <h5 className="text-secondary fw-bold">
                              {this.props.t("LPHT Rate")}
                            </h5>
                          </label>
                        </div>
                        <div className="col-md-8">
                          <input
                            className="form-control fs-5"
                            disabled
                            type="text"
                            name="lpht"
                            placeholder="Different Rate"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <div className="col-md-6 col-12">
                      <div className="row">
                        <div className="col-md-4">
                          <label htmlFor="real" className="col-form-label">
                            <h5 className="text-secondary fw-bold">
                              {this.props.t("REAL Rate")}
                            </h5>
                          </label>
                        </div>
                        <div className="col-md-8">
                          <input
                            className="form-control fs-5"
                            disabled
                            type="text"
                            name="real"
                            placeholder="Different Rate"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <div className="row">
                        <div className="col-md-4 text-start text-lg-center">
                          <label htmlFor="jiram" className="col-form-label">
                            <h5 className="text-secondary fw-bold">
                              {this.props.t("JIRAM Rate")}
                            </h5>
                          </label>
                        </div>
                        <div className="col-md-8">
                          <input
                            className="form-control fs-5"
                            disabled
                            type="text"
                            name="jiram"
                            placeholder="Different Rate"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label
                      htmlFor="mobile1"
                      className="col-md-2 col-form-label"
                    >
                      <h5 className="text-secondary fw-bold">Mobile no.1</h5>
                    </label>
                    <div className="col-md-10">
                      <input
                        className="form-control fs-5"
                        disabled
                        type="number" onWheel={(e) => e.target.blur()}
                        name="mobile1"
                        placeholder="+91 (132)(564)(9872)"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label
                      htmlFor="mobile2"
                      className="col-md-2 col-form-label"
                    >
                      <h5 className="text-secondary fw-bold">Mobile no.2</h5>
                    </label>
                    <div className="col-md-10">
                      <input
                        className="form-control fs-5"
                        disabled
                        type="number" onWheel={(e) => e.target.blur()}
                        name="mobile2"
                        placeholder="+91 (132)(564)(9872)"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label htmlFor="email" className="col-md-2 col-form-label">
                      <h5 className="text-secondary fw-bold">Email ID</h5>
                    </label>
                    <div className="col-md-10">
                      <input
                        className="form-control fs-5"
                        disabled
                        type="number" onWheel={(e) => e.target.blur()}
                        name="email"
                        placeholder="Enter a valid Email ID"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label htmlFor="sname" className="col-md-2 col-form-label">
                      <h5 className="text-secondary fw-bold">{this.props.t("Short Name")}</h5>
                    </label>
                    <div className="col-md-10">
                      <input
                        className="form-control fs-5"
                        disabled
                        type="text"
                        name="sname"
                        placeholder="P3Y"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label htmlFor="since" className="col-md-2 col-form-label">
                      <h5 className="text-secondary fw-bold">{this.props.t("Since")}</h5>
                    </label>
                    <div className="col-md-10">
                      <input
                        className="form-control fs-5"
                        disabled
                        type="text"
                        name="since"
                        placeholder="2001"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label
                      htmlFor="tagline"
                      className="col-md-2 col-form-label"
                    >
                      <h5 className="text-secondary fw-bold">{this.props.t("Tagline")}</h5>
                    </label>
                    <div className="col-md-10">
                      <input
                        className="form-control fs-5"
                        disabled
                        type="text"
                        name="tagline"
                        placeholder="#Tagline"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label htmlFor="notes" className="col-md-2 col-form-label">
                      <h5 className="text-secondary fw-bold">Admin Notes</h5>
                    </label>
                    <div className="col-md-10">
                      <textarea
                        className="form-control fs-5"
                        disabled
                        type="text"
                        name="notes"
                        rows="5"
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-md-12 text-end">
                    <Button
                      color="primary"
                      className="fs-4 px-5"
                      type="submit"
                    >
                      Submit
                    </Button>
                  </div>
                </form>
              </CardBody>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(viewExternalUnit);
